import {UserRole} from '../../types/enums';

import {
  roleTargetCheck,
  roleAssetCheck,
  roleAssetMemberCheck,
  roleSelfCheck,
  selfCheck,
  roleProjectStatusCheck,
  linkPermissionCheck,
} from './checks';

export const Policies = {
  InviteUser: roleTargetCheck(UserRole.Manager),
  DeleteUser: roleTargetCheck(UserRole.Admin),
  DeactivateUserPolicy: roleTargetCheck(UserRole.Manager),
  ReactivateUser: roleTargetCheck(UserRole.Manager),
  ReadProject: roleAssetCheck(UserRole.Manager),
  CreateProject: roleAssetCheck(UserRole.Manager),
  StartProcessing: roleAssetCheck(UserRole.Manager),
  UpdateProject: roleAssetCheck(UserRole.Manager),
  DeleteProject: roleProjectStatusCheck(UserRole.Manager),
  CreateCaptureData: roleAssetCheck(UserRole.Manager),
  UpdateCaptureData: roleAssetCheck(UserRole.Manager),
  OpenConnect: roleAssetMemberCheck(UserRole.Member),
  UpdateUser: roleSelfCheck(UserRole.Admin),
  ReadUser: roleSelfCheck(UserRole.Manager),
  ReadReports: linkPermissionCheck(UserRole.Viewer),
  ReadDownloads: linkPermissionCheck(UserRole.Viewer),
  ReadPresentations: linkPermissionCheck(UserRole.Viewer),
  ReadSelf: selfCheck,
};
